import { Card } from 'antd'
import React, { useState } from 'react'
import './video-materials.less'

const tutorials_data = [
  {
    youtubeIndex: 1,
    attributes: {
      title:
        "Didaktik o'yin: Hayot xavfsizligi asoslari | Bolalar uchun interaktiv mashg'ulot",
      link_youtube: 'https://www.youtube.com/embed/C-K6KiY2nQQ',
    },
  },
  {
    youtubeIndex: 4,
    attributes: {
      title:
        'Дидактическая игра по ОБЖ | Развивающая игра для детей | Безопасность в повседневной жизни',
      link_youtube: 'https://www.youtube.com/embed/CPJ9djoIH-k',
    },
  },
  {
    youtubeIndex: 2,
    attributes: {
      title:
        "Didaktik to‘plam: Meva va sabzavotlar | Bolalar uchun rivojlantiruvchi o'yin",
      link_youtube: 'https://www.youtube.com/embed/6JsS0wP6Sm0',
    },
  },
  {
    youtubeIndex: 11,
    attributes: {
      title: 'Дидактический набор: Фрукты и овощи | Развивающая игра для детей',
      link_youtube: 'https://www.youtube.com/embed/02xWJCa7Y1s',
    },
  },
  {
    youtubeIndex: 3,
    attributes: {
      title:
        "Interaktiv o'yin: Sog'lom va zararli ovqatlar | Bolalar bilan foydali ovqatlanishni o'rganamiz",
      link_youtube: 'https://www.youtube.com/embed/NIJ2x390by0',
    },
  },
  {
    youtubeIndex: 9,
    attributes: {
      title:
        'Интерактивное пособие: Здоровая и вредная еда | Учим детей питанию играя',
      link_youtube: 'https://www.youtube.com/embed/tRBa3GkLLjk',
    },
  },
  {
    youtubeIndex: 5,
    attributes: {
      title:
        'Uy hayvonlari va yovvoyi hayvonlar | Qiziqarli o‘yin bolalar uchun!',
      link_youtube: 'https://www.youtube.com/embed/OWKyX9huSy0',
    },
  },
  {
    youtubeIndex: 7,
    attributes: {
      title: 'Домашние и дикие животные | Дидактическая игра для малышей',
      link_youtube: 'https://www.youtube.com/embed/-RgVn54FyYE',
    },
  },
  {
    youtubeIndex: 6,
    attributes: {
      title:
        'Interfaol qo‘llanma: Loto «Sport turlari» | Bolalar uchun o‘yin orqali o‘rganish',
      link_youtube: 'https://www.youtube.com/embed/F8RAdBNNRm8',
    },
  },
  {
    youtubeIndex: 10,
    attributes: {
      title:
        'Интерактивное пособие: Лото «Виды спорта» | Обучающая игра для детей',
      link_youtube: 'https://www.youtube.com/embed/N6tdvd-6E1Y',
    },
  },
  {
    youtubeIndex: 8,
    attributes: {
      title: 'Sabzavot va Mevalar Lotosi | Interfaol darsligi',
      link_youtube: 'https://www.youtube.com/embed/KoD-fQJ2A4E',
    },
  },
  {
    youtubeIndex: 12,
    attributes: {
      title: 'Лото «Овощи и фрукты» | Интерактивная игра',
      link_youtube: 'https://www.youtube.com/embed/pM234nWh1mc',
    },
  },
]

export const VideoMaterials = () => {
  const [tutorials, setTutorials] = useState<any>(tutorials_data)

  // useEffect(() => {
  //   axios
  //     .get(
  //       'https://strapi.bbit.uz/api/tutorials?populate=linkYoutube&locale=all',
  //     )
  //     .then((res) => setTutorials(localizeStrapi(res.data.data)))
  // }, [t])

  return (
    <div className="tutorials">
      {tutorials.map((tutorial, index) => {
        return (
          <Card key={index} className="tutorial">
            <p className="tutorial__title">{tutorial.attributes.title}</p>
            {/* <p className="tutorial__description">
          {tutorial.attributes.description}
        </p> */}
            <div className="tutorial__video">
              <iframe
                allowFullScreen={true}
                allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                id="player"
                src={tutorial.attributes.link_youtube}
                frameBorder="0"></iframe>
            </div>
          </Card>
        )
      })}
    </div>
  )
}
